import * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AllCouriersQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AllCouriersQuery = { __typename?: 'Query', AllCouriers: Array<{ __typename?: 'Courier', indicative?: string | null, courierId: number, etaInterval: number }> };


export const AllCouriersDocument = gql`
    query AllCouriers {
  AllCouriers {
    indicative
    courierId
    etaInterval
  }
}
    `;

/**
 * __useAllCouriersQuery__
 *
 * To run a query within a React component, call `useAllCouriersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCouriersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCouriersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllCouriersQuery(baseOptions?: Apollo.QueryHookOptions<AllCouriersQuery, AllCouriersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCouriersQuery, AllCouriersQueryVariables>(AllCouriersDocument, options);
      }
export function useAllCouriersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCouriersQuery, AllCouriersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCouriersQuery, AllCouriersQueryVariables>(AllCouriersDocument, options);
        }
export type AllCouriersQueryHookResult = ReturnType<typeof useAllCouriersQuery>;
export type AllCouriersLazyQueryHookResult = ReturnType<typeof useAllCouriersLazyQuery>;
export type AllCouriersQueryResult = Apollo.QueryResult<AllCouriersQuery, AllCouriersQueryVariables>;